export const NAME = 'featured';